<template>
  <div>
    <h1>Ingeniería de Proceso</h1>
    <p>Nos especializamos en la mejora continua de procesos industriales.</p>
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';

export default {
  name: 'IngenieriaDeProceso',
  setup() {
    useSEO({
      title: 'Ingeniería de Proceso',
      description: 'Mejora continua de tus procesos industriales con Frenkel Engineering. Análisis, optimización y rediseño de procesos para maximizar eficiencia y calidad productiva.',
      path: '/ingenieria-de-proceso',
    });
  }
};
</script>

<style scoped>
h1 {
  text-align: justify;
  margin-top: 20px;
}
</style>
